import React from 'react';
import styled from 'styled-components';

import PublicGamesListTool from "../games/tools/PublicGamesListTool";

export default function PublicGamesApp() {

  return (
    <Wrapper currentName={'games'}>

      <PublicGamesListTool/>

    </Wrapper>
  );
}

const Wrapper = styled.div`

`;